export enum TableSettingsTabEnum {
    FILTER = 0,
    SORT = 1,
}
